/* Parbiart — visszaszámláló és váltás a „megjelent" állapotra: a beharangozó szekció
   (sections/pb-beharangozo.liquid), a limitált landing (sections/pb-limitalt.liquid) és a terméklap
   (snippets/pb-termek-buborekok.liquid). A cél másodpercben (Unix-idő) a gyökér data-pb-cel attribútumában van.
   JS nélkül a Liquid szerinti állapot látszik.

   A gyökér további, nem kötelező attribútumai (10-19, drop):
   - data-pb-zar-id: a megjelenéskor a lap minden [data-pb-zar="<id>"] eleme törlődik (pl. a termékrácsot rejtő <style>);
   - data-pb-ujratolt: CSS-szelektor. Ha a lap még a megjelenés előtti állapotban jött (volt mit törölni), és a
     megjelenés után ez nem talál semmit (a termékek időzítve, csak most kerültek elő), a lap egyszer újratölt. */
(function () {
  function indit(gyoker) {
    if (gyoker.dataset.pbKesz) return;
    gyoker.dataset.pbKesz = '1';
    var cel = Number(gyoker.dataset.pbCel) * 1000;
    if (!cel) return;
    var elott = gyoker.querySelectorAll('[data-pb-elott]');
    var utan = gyoker.querySelectorAll('[data-pb-utan]');
    var mezo = {};
    gyoker.querySelectorAll('[data-pb-c]').forEach(function (el) { mezo[el.dataset.pbC] = el; });
    var idozito;

    function ir(kulcs, ertek) {
      if (mezo[kulcs]) mezo[kulcs].textContent = String(ertek);
    }
    function felold() {
      var id = gyoker.dataset.pbZarId;
      if (!id) return;
      var zarak = document.querySelectorAll('[data-pb-zar="' + id + '"]');
      if (!zarak.length) return;
      zarak.forEach(function (el) { el.remove(); });
      var szelektor = gyoker.dataset.pbUjratolt;
      if (!szelektor || document.querySelector(szelektor)) return;
      // egyszer, és kis késéssel: a megjelenés pillanatában ne egyszerre töltsön újra mindenki
      var kulcs = 'pb-ujratolt:' + location.pathname + ':' + gyoker.dataset.pbCel;
      try {
        if (sessionStorage.getItem(kulcs)) return;
        sessionStorage.setItem(kulcs, '1');
      } catch (e) {
        return;
      }
      setTimeout(function () { location.reload(); }, 3000 + Math.random() * 7000);
    }
    function lep() {
      var hatra = cel - Date.now();
      var megjelent = hatra <= 0;
      elott.forEach(function (el) { el.hidden = megjelent; });
      utan.forEach(function (el) { el.hidden = !megjelent; });
      if (megjelent) {
        clearInterval(idozito);
        felold();
        return;
      }
      var mp = Math.floor(hatra / 1000);
      ir('nap', Math.floor(mp / 86400));
      ir('ora', Math.floor((mp % 86400) / 3600));
      ir('perc', Math.floor((mp % 3600) / 60));
      ir('mp', mp % 60);
    }
    idozito = setInterval(lep, 1000);
    lep();
  }
  function mind(gyoker) { gyoker.querySelectorAll('[data-pb-cel]').forEach(indit); }
  mind(document);
  document.addEventListener('shopify:section:load', function (e) { mind(e.target); });
})();
